import api from './api';

class SourcingAwardService {

  /*
  =============================
  Award Actions
  =============================
  */

  // Fetch all awards (used for the management page)
  static async getAwards() {
    try {
      const response = await api.get('/sourcing/awards');
      return response.data;
    } catch (error) {
      console.error('Error fetching awards:', error);
      throw this.handleError(error);
    }
  }

  // Approve or Reject an award
  static async approveAward(awardId, data) {
    try {
      const response = await api.put(
        `/sourcing/awards/${awardId}/approve`,
        data
      );
      return response.data;
    } catch (error) {
      console.error('Error approving award:', error);
      throw this.handleError(error);
    }
  }

  // Create contract prefill from an approved award
  static async createContractPrefill(awardId) {
    try {
      const response = await api.post(
        `/sourcing/awards/${awardId}/create-contract`
      );
      return response.data;
    } catch (error) {
      console.error('Error creating contract prefill:', error);
      throw this.handleError(error);
    }
  }

  /*
  =============================
  ERROR HANDLER
  (Matched to SourcingRfpService)
  =============================
  */

  static handleError(error) {
    if (error.response) {
      const errorData = error.response.data;

      const errorMessage =
        errorData?.message ||
        errorData?.error ||
        (errorData?.errors?.length
          ? errorData.errors.map(e => e.msg || e.message).join(', ')
          : 'An error occurred');

      return {
        message: errorMessage,
        status: error.response.status,
        data: errorData,
      };
    }

    if (error.request) {
      return {
        message: 'Network error - please check your connection',
        status: 0,
      };
    }

    return {
      message: error.message || 'Unexpected error occurred',
      status: 0,
    };
  }
}

export default SourcingAwardService;